import axios from 'axios';
import { API_CONFIG } from '../config/apiConfig';

class LocalDbService {
  constructor() {
    const envBase = typeof process !== 'undefined' ? (process.env.REACT_APP_LOCAL_DB_URL || '') : '';
    this.baseUrl = (envBase && envBase.trim() !== '') ? envBase.trim() : API_CONFIG.LOCAL_DB.BASE_URL;
    this.endpoints = API_CONFIG.LOCAL_DB.ENDPOINTS;
  }

  _buildUrl(path) {
    return `${this.baseUrl}${path}`;
  }

  _normalizeOrder(o) {
    const ordSer = o['Ord.Ser'] ?? o.ord_ser ?? o.id ?? o.numero ?? null;
    const normDate = (s) => {
      if (!s) return null;
      const str = typeof s === 'string' ? s.trim() : String(s);
      if (/^\d{2}\/\d{2}\/\d{4}$/.test(str)) {
        return `${str.slice(6,10)}-${str.slice(3,5)}-${str.slice(0,2)}`;
      }
      return str;
    };
    const dataIncl =
      normDate(o['Data Inclusao'] ?? o.data_inclusao ?? o.created_at ?? o.data ?? null);
    const cliente =
      o['Cliente'] ?? o.cliente ?? o.customer_name ?? o.nome_cliente ?? null;
    const serviceOrderCustomerId =
      o['service_order_customer_id'] ?? o.cod_cliente ?? o.codigo_cliente ?? o.cliente_id ?? o.customer_id ?? null;
    const descricao =
      o['Descrição'] ?? o.descricao ?? o.description ?? o.desc ?? null;
    const problema =
      o['Problema'] ?? o.problema ?? o.problem ?? o.prob ?? null;
    const posicao =
      o['Posição'] ?? o.posicao ?? o.status ?? null;
    const tecnico =
      o['Técnico'] ?? o.tecnico ?? o.technician_name ?? o.nome_tecnico ?? null;
    const atendente =
      o['Atendente'] ?? o.atendente ?? o.attendant_name ?? o.nome_atendente ?? null;
    const faturada =
      o['Faturada'] ?? o.faturada ?? o.billed ?? null;
    const cobertura =
      o['Cobertura'] ?? o.cobertura ?? o.coverage ?? null;
    const vlrSer =
      o['Vlr.cobrado ser'] ?? o.vlr_ser ?? o.service_total ?? o.valor_servico ?? 0;
    const vlrMat =
      o['Vlr.cobrado mat'] ?? o.vlr_mat ?? o.material_total ?? o.valor_material ?? 0;
    const localEntrega =
      o['Local entrega'] ?? o.local_entrega ?? o.delivery_location ?? null;
    const marcaModelo =
      o['Marca/modelo'] ?? o.marca_modelo ?? o.brand_model ?? null;
    const fabricante =
      o['Fabricante'] ?? o.fabricante ?? o.manufacturer ?? null;
    return {
      'Ord.Ser': ordSer,
      'Data Inclusao': dataIncl,
      'Cliente': cliente,
      'service_order_customer_id': serviceOrderCustomerId,
      'Descrição': descricao,
      'Problema': problema,
      'Posição': posicao,
      'Técnico': tecnico,
      'Atendente': atendente,
      'Faturada': faturada,
      'Cobertura': cobertura,
      'Vlr.cobrado ser': Number(vlrSer) || 0,
      'Vlr.cobrado mat': Number(vlrMat) || 0,
      'Local entrega': localEntrega,
      'Marca/modelo': marcaModelo,
      'Fabricante': fabricante
    };
  }

  async health() {
    const url = this._buildUrl(this.endpoints.HEALTH);
    const response = await axios.get(url, { timeout: API_CONFIG.TIMEOUT.HEALTH_CHECK });
    return response.data ?? { ok: true };
  }

  async getOrders({ zaffariOnly = true } = {}) {
    const url = this._buildUrl(this.endpoints.ORDERS);
    const qs = zaffariOnly ? '?zaffariOnly=true' : '';
    const response = await axios.get(`${url}${qs}`, { timeout: API_CONFIG.TIMEOUT.DEFAULT });
    const payload = Array.isArray(response.data) ? response.data : (response.data?.data ?? []);
    return Array.isArray(payload) ? payload.map(o => this._normalizeOrder(o)) : [];
  }

  async importOrders(data = []) {
    if (!Array.isArray(data) || data.length === 0) return { success: true, count: 0 };
    const url = this._buildUrl(this.endpoints.IMPORT_ORDERS);
    const response = await axios.post(
      url,
      { data },
      { headers: { 'Content-Type': 'application/json' }, timeout: API_CONFIG.TIMEOUT.LONG_REQUEST }
    );
    return response.data ?? { success: true, count: data.length };
  }
}

const localDbService = new LocalDbService();
export default localDbService;
